import React, { ReactElement } from 'react'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import HeaderFont from '../../HelperClass/HeaderFont'
import HeaderTemplate from '../../HelperClass/Template/Header'
import HeaderItem from '../../HelperClass/HeaderItem'
import { BasketballFormat } from '../../HelperClass/StandingsRowTypes'

export type Props = {
    /**
     * Is there a more button
     */
    hasMore?: boolean
    /**
     * Is there a streak value
     */
    showStreak?: boolean

    format: BasketballFormat
} & TestID

const BasketBallHeader = ({ format, hasMore, showStreak, testID }: Props): ReactElement => {
    const pointLabel = format === 'OTHER' || format === 'BBL' ? 'Pkt.' : '%'
    return (
        <HeaderTemplate competitorLabel="Team" testID={testID} hasMore={hasMore}>
            <HeaderItem width={24}>
                <HeaderFont align="center">Sp.</HeaderFont>
            </HeaderItem>
            <HeaderItem width={[42, 42, 46]}>
                <HeaderFont align="center">S-N</HeaderFont>
            </HeaderItem>
            {format === 'OTHER' || format === 'BBL' ? (
                <HeaderItem width={36}>
                    <HeaderFont align="center">Diff.</HeaderFont>
                </HeaderItem>
            ) : null}
            <HeaderItem width={40}>
                <HeaderFont align="center">{pointLabel}</HeaderFont>
            </HeaderItem>
            {format === 'NBA' ? (
                <HeaderItem width={[31, 31, 32]}>
                    <HeaderFont align="center">GB</HeaderFont>
                </HeaderItem>
            ) : null}
            {format !== 'OTHER' && showStreak ? (
                <HeaderItem width={31}>
                    <HeaderFont align="center">Serie</HeaderFont>
                </HeaderItem>
            ) : null}
        </HeaderTemplate>
    )
}

export default BasketBallHeader
